import React, { useEffect, useState } from 'react';
import { X, Download, CalendarCheck, CheckCircle } from 'lucide-react';
interface LeadModalProps {
  open: boolean;
  onClose: () => void;
}
export function LeadModal({
  open,
  onClose
}: LeadModalProps) {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({
    nombre: '',
    email: '',
    telefono: '',
    capital: ''
  });
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (open) window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [open, onClose]);
  if (!open) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  const handleClose = () => {
    onClose();
    setTimeout(() => setSubmitted(false), 300);
  };
  const inputClass = 'w-full px-5 py-3.5 bg-white border border-bunker/15 rounded-2xl focus:border-pitahaya focus:outline-none focus:ring-2 focus:ring-pitahaya/20 font-sans text-bunker placeholder:text-bunker/30 transition-all';
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-bunker/80 backdrop-blur-md overflow-y-auto animate-in fade-in duration-200" onClick={handleClose} role="dialog" aria-modal="true" data-id="element-48">
      <div className="relative bg-earth w-full max-w-lg my-8 rounded-3xl shadow-2xl shadow-bunker/40 overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-49">
        <button onClick={handleClose} className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center rounded-full bg-bunker/5 text-bunker/60 hover:bg-bunker/10 hover:text-pitahaya transition-all z-10" aria-label="Cerrar" data-id="element-50">
          <X className="w-5 h-5" data-id="element-51" />
        </button>

        {!submitted ? <div className="p-8 md:p-10" data-id="element-52">
            <div className="inline-flex items-center gap-2 mb-4 bg-pitahaya/10 px-3 py-1.5 rounded-full" data-id="element-53">
              <Download className="w-4 h-4 text-pitahaya" data-id="element-54" />
              <span className="text-pitahaya font-sans font-bold text-[11px] tracking-widest uppercase" data-id="element-55">
                Acceso Gratuito
              </span>
            </div>

            <h3 className="font-serif text-2xl md:text-3xl font-bold text-bunker leading-tight mb-3" data-id="element-56">
              Descarga la{' '}
              <span className="text-pitahaya" data-id="element-57">
                Guía de Blindaje Patrimonial
              </span>{' '}
              y agenda tu entrevista privada
            </h3>

            <p className="font-sans text-bunker/60 text-sm mb-7 leading-relaxed" data-id="element-58">
              Recibe la guía en tu correo y un asesor te contactará en menos de
              24 horas para agendar tu sesión estratégica sin costo.
            </p>

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-59">
              <div data-id="element-60">
                <label className="block font-sans text-xs font-semibold text-bunker/70 mb-1.5 ml-1" data-id="element-61">
                  Nombre completo
                </label>
                <input type="text" required value={form.nombre} onChange={e => setForm({
              ...form,
              nombre: e.target.value
            })} className={inputClass} placeholder="Tu nombre" data-id="element-62" />
              </div>

              <div data-id="element-63">
                <label className="block font-sans text-xs font-semibold text-bunker/70 mb-1.5 ml-1" data-id="element-64">
                  Correo electrónico
                </label>
                <input type="email" required value={form.email} onChange={e => setForm({
              ...form,
              email: e.target.value
            })} className={inputClass} placeholder="tu@correo.com" data-id="element-65" />
              </div>

              <div data-id="element-66">
                <label className="block font-sans text-xs font-semibold text-bunker/70 mb-1.5 ml-1" data-id="element-67">
                  WhatsApp / Teléfono
                </label>
                <input type="tel" required value={form.telefono} onChange={e => setForm({
              ...form,
              telefono: e.target.value
            })} className={inputClass} placeholder="+52 ..." data-id="element-68" />
              </div>

              <div data-id="element-69">
                <label className="block font-sans text-xs font-semibold text-bunker/70 mb-1.5 ml-1" data-id="element-70">
                  Capital aproximado a proteger
                </label>
                <select required value={form.capital} onChange={e => setForm({
              ...form,
              capital: e.target.value
            })} className={inputClass + ' appearance-none bg-no-repeat bg-right pr-10'} style={{
              backgroundImage: "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%230A0A0A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\")",
              backgroundPosition: 'right 1rem center'
            }} data-id="element-71">
                  <option value="" data-id="element-72">Selecciona un rango</option>
                  <option value="89-200" data-id="element-73">$89,000 - $200,000 MXN</option>
                  <option value="200-500" data-id="element-74">$200,000 - $500,000 MXN</option>
                  <option value="500-1m" data-id="element-75">$500,000 - $1,000,000 MXN</option>
                  <option value="1m+" data-id="element-76">Más de $1,000,000 MXN</option>
                </select>
              </div>

              <button type="submit" className="w-full bg-pitahaya text-white font-sans font-bold uppercase tracking-wider px-6 py-4 rounded-full hover:bg-pitahaya-dark transition-all hover:scale-[1.01] active:scale-[0.99] shadow-lg shadow-pitahaya/30 flex items-center justify-center gap-2 mt-2" data-id="element-77">
                <CalendarCheck className="w-5 h-5" data-id="element-78" />
                Recibir Guía y Agendar Entrevista
              </button>

              <p className="text-center font-sans text-xs text-bunker/50 pt-1" data-id="element-79">
                🔒 Tus datos están protegidos. No compartimos tu información.
              </p>
            </form>
          </div> : <div className="p-10 text-center" data-id="element-80">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-pitahaya rounded-full mb-6 shadow-lg shadow-pitahaya/30" data-id="element-81">
              <CheckCircle className="w-8 h-8 text-white" data-id="element-82" />
            </div>
            <h3 className="font-serif text-3xl font-bold text-bunker mb-4" data-id="element-83">
              ¡Listo, {form.nombre.split(' ')[0] || 'inversionista'}!
            </h3>
            <p className="font-sans text-bunker/70 leading-relaxed mb-6" data-id="element-84">
              Hemos enviado la{' '}
              <strong className="text-pitahaya" data-id="element-85">
                Guía de Blindaje Patrimonial
              </strong>{' '}
              a <strong data-id="element-86">{form.email}</strong>. Un asesor te contactará en menos
              de 24 horas para agendar tu entrevista privada.
            </p>
            <button onClick={handleClose} className="bg-bunker text-white font-sans font-bold uppercase tracking-wider px-8 py-3 rounded-full hover:bg-pitahaya transition-colors" data-id="element-87">
              Continuar Explorando
            </button>
          </div>}
      </div>
    </div>;
}